import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import { useEmployeeStore } from '@/stores/employee'
import { useUserStore } from '@/stores/user'

const adminAabGuard = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) => {
  const employeeStore = useEmployeeStore()
  const userStore = useUserStore()

  try {
    const isUserEmpty = Object.keys(userStore.user).length === 0

    if (isUserEmpty) {
      await userStore.refreshUser()
    }

    if (!userStore.isAab) {
      return next({ name: 'dashboard' })
    }

    if (!employeeStore.employee) {
      await employeeStore.setEmployee()
    }

    return employeeStore.isAdmin ? next() : next({ name: 'dashboard' })
  } catch {
    return next({ name: 'dashboard' })
  }
}

export const aabRoutes = [
  {
    name: 'aab',
    path: 'aab',
    beforeEnter: adminAabGuard,
    children: [
      {
        path: 'dashboard',
        name: 'aab-dashboard',
        meta: {
          gtmId: 'GTM_AAB_PAGE_DASHBOARD'
        },
        component: () => import('../views/aab/DashboardAab.vue')
      },
      {
        path: 'collaborators-management',
        name: 'aab-collaborators-management',
        meta: {
          gtmId: 'GTM_AAB_PAGE_TEAM_MANAGEMENT'
        },
        component: () => import('../views/aab/CollaboratorsManagementAab.vue')
      },
      {
        path: 'bookings-management',
        name: 'aab-bookings-management',
        meta: {
          gtmId: 'GTM_AAB_PAGE_BOOKINGS'
        },
        component: () => import('../views/aab/BookingsManagementAab.vue')
      },
      {
        path: 'company-information',
        name: 'aab-company-information',
        meta: {
          gtmId: 'GTM_AAB_PAGE_COMPANY_SETTINGS'
        },
        component: () => import('../views/aab/CompanyInformationAab.vue')
      },
      {
        path: 'loyalty-management',
        name: 'aab-loyalty-management',
        meta: {
          gtmId: 'GTM_AAB_PAGE_LOYALTY'
        },
        component: () => import('../views/aab/LoyaltyManagementAab.vue')
      }
    ]
  }
]
